module.exports = __webpack_public_path__ + "static/img/img4-3.6483366.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/yxds2021/img4-3.png
// module id = PlYw
// module chunks = 0